<template>
  <div class="view-home">
    <div class="container">
      <div class="quiz-status my-4">
        <div class="card" v-show="countdown">
          <ul>
            <li class="time">
              {{ countdown }}
            </li>
            <li class="recording" v-if="quiz.proctoring">
              {{ $t('testing.recording') }}
            </li>
            <li class="interruption" v-if="quiz.proctoring">
              {{ $t('testing.interruption') }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container questions-wrap">
      <h2>
        {{ $t('communications.title') }}
      </h2>
      <h3>
        {{$t('communications.methodology')}}
      </h3>
      <div class="collaboration-desc" v-html="$t('communications.instruction') ">

      </div>
      <table class="communications-table">
        <thead>
        <tr>
          <th>Рейтинг</th>
          <th>{{$t('communications.table-title1')}}</th>
          <th>{{$t('communications.table-title2')}}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>1 {{$t('communications.place')}}</td>
          <td><el-select class="w-100"  v-model="communicationsAnswers.communicationsFirstPlace.sphere" :placeholder="$t('communications.select_sphere')">
            <el-option
                v-if="$i18n.locale == 'ru'"
                v-for="item in optionsSpheresRU"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
            <el-option
                v-if="$i18n.locale == 'kz'"
                v-for="item in optionsSpheresKZ"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select></td>
          <td><el-select class="w-100" v-model="communicationsAnswers.communicationsFirstPlace.role" multiple :placeholder="$t('communications.select_role')">
            <el-option
                v-if="$i18n.locale == 'ru'"
                v-for="item in optionsRolesRU"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
            <el-option
                v-if="$i18n.locale == 'kz'"
                v-for="item in optionsRolesKZ"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select></td>
        </tr>
        <tr>
          <td>2 {{$t('communications.place')}}</td>
          <td><el-select class="w-100"  v-model="communicationsAnswers.communicationsSecondPlace.sphere" :placeholder="$t('communications.select_sphere')">
            <el-option
                v-if="$i18n.locale == 'ru'"
                v-for="item in optionsSpheresRU"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
            <el-option
                v-if="$i18n.locale == 'kz'"
                v-for="item in optionsSpheresKZ"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select></td>
          <td><el-select class="w-100"  v-model="communicationsAnswers.communicationsSecondPlace.role" multiple :placeholder="$t('communications.select_role')">
            <el-option
                v-if="$i18n.locale == 'ru'"
                v-for="item in optionsRolesRU"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
            <el-option
                v-if="$i18n.locale == 'kz'"
                v-for="item in optionsRolesKZ"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select></td>
        </tr>
        <tr>
          <td>3 {{$t('communications.place')}}</td>
          <td><el-select class="w-100" v-model="communicationsAnswers.communicationsThirdPlace.sphere" :placeholder="$t('communications.select_sphere')">
            <el-option
                v-if="$i18n.locale == 'ru'"
                v-for="item in optionsSpheresRU"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
            <el-option
                v-if="$i18n.locale == 'kz'"
                v-for="item in optionsSpheresKZ"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select></td>
          <td><el-select class="w-100"  v-model="communicationsAnswers.communicationsThirdPlace.role" multiple :placeholder="$t('communications.select_role')">
            <el-option
                v-if="$i18n.locale == 'ru'"
                v-for="item in optionsRolesRU"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
            <el-option
                v-if="$i18n.locale == 'kz'"
                v-for="item in optionsRolesKZ"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select></td>
        </tr>
        </tbody>
      </table>


      <!--      <button @click="sendCollaborationResults">Отправить</button>-->
      <el-button @click="openModal"
                 class="btn btn-danger">{{ $t('testing.finish-modal-button') }}
      </el-button>

    </div>
    <b-modal id="exit-modal" hide-footer hide-header>
      <div id="modal-wrapper">
        <div id="dialog">
          <button @click="$bvModal.hide('exit-modal')" type="button" class="close" data-dismiss="modal"
                  aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
          <img class="modal-warning-img mb-3" src="/images/profile/modal-warning.svg">
          <h3 class="mb-0">{{modalTitle}}</h3>
          <p>{{ $t('testing.finish-modal-desc') }}</p>
          <div class="clearfix pt-3">
            <el-button @click="sendCommunicationsResults" class="btn btn-primary mx-2">
              {{ $t('testing.finish-modal-button') }}
            </el-button>
            <a @click="$bvModal.hide('exit-modal')"
               class="btn btn-outline-primary mx-2">{{ $t('testing.finish-modal-cancel') }}</a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import 'katex/dist/katex.min.css';
import Loader from '../../components/Loader';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue';

Vue.use(VueViewer)
export default {
  name: "Index",
  data() {
    return {
      modalTitle: this.$t('testing.finish-modal-title'),
      timerInterval: null,
      countdown: 0,
      quiz: '',
      optionsSpheresRU: [
        {
          value: 'СЕМЬЯ',
          label: 'СЕМЬЯ'
        },
        {
          value: 'ШКОЛА',
          label: 'ШКОЛА'
        },
        {
          value: 'ХОББИ',
          label: 'ХОББИ'
        },
        {
          value: 'ДРУЗЬЯ',
          label: 'ДРУЗЬЯ'
        },
        {
          value: 'СПОРТ',
          label: 'СПОРТ'
        },
        {
          value: 'ТВОРЧЕСТВО',
          label: 'ТВОРЧЕСТВО'
        },
        {
          value: 'СОЦ.СЕТИ',
          label: 'СОЦ.СЕТИ'
        },
        {
          value: 'ПУТЕШЕСТВИЯ',
          label: 'ПУТЕШЕСТВИЯ'
        }
      ],
      optionsSpheresKZ: [
        {
          value: 'ЖАНҰЯ',
          label: 'ЖАНҰЯ'
        },
        {
          value: 'МЕКТЕП',
          label: 'МЕКТЕП'
        },
        {
          value: 'ХОББИ',
          label: 'ХОББИ'
        },
        {
          value: 'ДОСТАР',
          label: 'ДОСТАР'
        },
        {
          value: 'СПОРТ',
          label: 'СПОРТ'
        },
        {
          value: 'ШЫҒАРМАШЫЛЫҚ',
          label: 'ШЫҒАРМАШЫЛЫҚ'
        },
        {
          value: 'ӘЛЕУМЕТТІК ЖЕЛІ',
          label: 'ӘЛЕУМЕТТІК ЖЕЛІ'
        },
        {
          value: 'САЯХАТ',
          label: 'САЯХАТ'
        }
      ],
      optionsRolesRU: [
        { value: 'БРАТ-СЕСТРА', label: 'БРАТ-СЕСТРА' },
        { value: 'БОГАТЫЙ ЧЕЛОВЕК', label: 'БОГАТЫЙ ЧЕЛОВЕК' },
        { value: 'ВДОХНОВИТЕЛЬ', label: 'ВДОХНОВИТЕЛЬ' },
        { value: 'ВНУК-ВНУЧКА', label: 'ВНУК-ВНУЧКА' },
        { value: 'ВЕСЕЛЬЧАК', label: 'ВЕСЕЛЬЧАК' },
        { value: 'ВОЛЕВОЙ ЧЕЛОВЕК', label: 'ВОЛЕВОЙ ЧЕЛОВЕК' },
        { value: 'ГАРМОНИЧНЫЙ', label: 'ГАРМОНИЧНЫЙ' },
        { value: 'ДЕВОЧКА-МАЛЬЧИК', label: 'ДЕВОЧКА-МАЛЬЧИК' },
        { value: 'ДОЧЬ-СЫН', label: 'ДОЧЬ-СЫН' },
        { value: 'ДУША КОМПАНИИ', label: 'ДУША КОМПАНИИ' },
        { value: 'ЗДОРОВЫЙ ЧЕЛОВЕК', label: 'ЗДОРОВЫЙ ЧЕЛОВЕК' },
        { value: 'ИДЕАЛИСТ', label: 'ИДЕАЛИСТ' },
        { value: 'ИНИЦИАТОР', label: 'ИНИЦИАТОР' },
        { value: 'ИСПОЛНИТЕЛЬ', label: 'ИСПОЛНИТЕЛЬ' },
        { value: 'КОЛЛЕКТИВИСТ', label: 'КОЛЛЕКТИВИСТ' },
        { value: 'КРАСИВЫЙ ЧЕЛОВЕК', label: 'КРАСИВЫЙ ЧЕЛОВЕК' },
        { value: 'КРИТИК', label: 'КРИТИК' },
        { value: 'ЛИДЕР', label: 'ЛИДЕР' },
        { value: 'МАТЕМАТИК', label: 'МАТЕМАТИК' },
        { value: 'МОДНИК', label: 'МОДНИК' },
        { value: 'МОТИВАТОР', label: 'МОТИВАТОР' },
        { value: 'НАДЕЖНЫЙ ДРУГ', label: 'НАДЕЖНЫЙ ДРУГ' },
        { value: 'НАХОДЧИВЫЙ ЧЕЛОВЕК', label: 'НАХОДЧИВЫЙ ЧЕЛОВЕК' },
        { value: 'НРАВСТВЕННЫЙ ЧЕЛОВЕК', label: 'НРАВСТВЕННЫЙ ЧЕЛОВЕК' },
        { value: 'ОБЩИТЕЛЬНЫЙ ЧЕЛОВЕК', label: 'ОБЩИТЕЛЬНЫЙ ЧЕЛОВЕК' },
        { value: 'ОДИНОЧКА', label: 'ОДИНОЧКА' },
        { value: 'ОПТИМИСТ', label: 'ОПТИМИСТ' },
        { value: 'ОРГАНИЗАТОР', label: 'ОРГАНИЗАТОР' },
        { value: 'ОРИГИНАЛ', label: 'ОРИГИНАЛ' },
        { value: 'ОТВЕТСТВЕННЫЙ', label: 'ОТВЕТСТВЕННЫЙ' },
        { value: 'ОТЗЫВЧИВЫЙ', label: 'ОТЗЫВЧИВЫЙ' },
        { value: 'ОТЛИЧНИК', label: 'ОТЛИЧНИК' },
        { value: 'ПЛЕМЯННИК-ПЛЕМЯННИЦА', label: 'ПЛЕМЯННИК-ПЛЕМЯННИЦА' },
        { value: 'ПРЕДПРИИМЧИВЫЙ', label: 'ПРЕДПРИИМЧИВЫЙ' },
        { value: 'ПРИНЦИПИАЛЬНЫЙ ЧЕЛОВЕК', label: 'ПРИНЦИПИАЛЬНЫЙ ЧЕЛОВЕК' },
        { value: 'РЕАЛИСТ', label: 'РЕАЛИСТ' },
        { value: 'САМОСТОЯТЕЛЬНЫЙ', label: 'САМОСТОЯТЕЛЬНЫЙ' },
        { value: 'СИЛЬНЫЙ ЧЕЛОВЕК', label: 'СИЛЬНЫЙ ЧЕЛОВЕК' },
        { value: 'СПОСОБНЫЙ ЧЕЛОВЕК', label: 'СПОСОБНЫЙ ЧЕЛОВЕК' },
        { value: 'СПРАВЕДЛИВЫЙ', label: 'СПРАВЕДЛИВЫЙ' },
        { value: 'СТРЕССОУСТОЙЧИВЫЙ', label: 'СТРЕССОУСТОЙЧИВЫЙ' },
        { value: 'ТАЛАНТЛИВЫЙ ЧЕЛОВЕК', label: 'ТАЛАНТЛИВЫЙ ЧЕЛОВЕК' },
        { value: 'ТВОРЧЕСКИЙ', label: 'ТВОРЧЕСКИЙ' },
        { value: 'УЧЕНИК (ЦА)', label: 'УЧЕНИК (ЦА)' },
        { value: 'УВАЖАЕМЫЙ ЧЕЛОВЕК', label: 'УВАЖАЕМЫЙ ЧЕЛОВЕК' },
        { value: 'УМНЫЙ', label: 'УМНЫЙ' },
        { value: 'УНИКАЛЬНЫЙ', label: 'УНИКАЛЬНЫЙ' },
        { value: 'ФИЗИЧЕСКИ ЛОВКИЙ', label: 'ФИЗИЧЕСКИ ЛОВКИЙ' },
        { value: 'ФИЗИЧЕСКИ РАЗВИТЫЙ', label: 'ФИЗИЧЕСКИ РАЗВИТЫЙ' },
        { value: 'ЦЕЛЕУСТРЕМЛЕННЫЙ ЧЕЛОВЕК', label: 'ЦЕЛЕУСТРЕМЛЕННЫЙ ЧЕЛОВЕК' },
        { value: 'ЦЕНИТЕЛЬ ПРЕКРАСНОГО', label: 'ЦЕНИТЕЛЬ ПРЕКРАСНОГО' },
        { value: 'ЧЕСТНЫЙ ЧЕЛОВЕК', label: 'ЧЕСТНЫЙ ЧЕЛОВЕК' },
        { value: 'ЧУВСТВИТЕЛЬНЫЙ', label: 'ЧУВСТВИТЕЛЬНЫЙ' },
        { value: 'ЭРУДИТ (НАЧИТАННЫЙ)', label: 'ЭРУДИТ (НАЧИТАННЫЙ)' }
      ],
      optionsRolesKZ: [
        { value: 'АҒА-ӘПКЕ (ТӘТЕ)', label: 'АҒА-ӘПКЕ (ТӘТЕ)' },
        { value: 'БАЙ АДАМ', label: 'БАЙ АДАМ' },
        { value: 'ШАБЫТТАНДЫРУШЫ', label: 'ШАБЫТТАНДЫРУШЫ' },
        { value: 'НЕМЕРЕ', label: 'НЕМЕРЕ' },
        { value: 'КӨҢІЛДІ АДАМ', label: 'КӨҢІЛДІ АДАМ' },
        { value: 'ЕРІК КҮШІ МЫҚТЫ АДАМ', label: 'ЕРІК КҮШІ МЫҚТЫ АДАМ' },
        { value: 'ҮЙЛЕСІМДІ', label: 'ҮЙЛЕСІМДІ' },
        { value: 'ҰЛ-ҚЫЗ', label: 'ҰЛ-ҚЫЗ' },
        { value: 'ҰЛЫМ-ҚЫЗЫМ', label: 'ҰЛЫМ-ҚЫЗЫМ' },
        { value: 'КОМПАНИЯНЫҢ ЖАНЫ', label: 'КОМПАНИЯНЫҢ ЖАНЫ' },
        { value: 'ДЕНСАУЛЫҒЫ МЫҚТЫ', label: 'ДЕНСАУЛЫҒЫ МЫҚТЫ' },
        { value: 'ИДЕАЛИСТ', label: 'ИДЕАЛИСТ' },
        { value: 'ИНИЦИАТОР', label: 'ИНИЦИАТОР' },
        { value: 'ОРЫНДАУШЫ', label: 'ОРЫНДАУШЫ' },
        { value: 'КӨПШІЛ', label: 'КӨПШІЛ' },
        { value: 'ӘДЕМІ АДАМ', label: 'ӘДЕМІ АДАМ' },
        { value: 'СЫНШЫ', label: 'СЫНШЫ' },
        { value: 'КӨШБАСШЫ', label: 'КӨШБАСШЫ' },
        { value: 'МАТЕМАТИК', label: 'МАТЕМАТИК' },
        { value: 'СӘНҚОЙ', label: 'СӘНҚОЙ' },
        { value: 'МОТИВАТОР', label: 'МОТИВАТОР' },
        { value: 'СЕНІМДІ ДОС', label: 'СЕНІМДІ ДОС' },
        { value: 'ТАПҚЫР АДАМ', label: 'ТАПҚЫР АДАМ' },
        { value: 'АДАМГЕРШІЛІГІ ЖОҒАРЫ', label: 'АДАМГЕРШІЛІГІ ЖОҒАРЫ' },
        { value: 'ҚАРЫМ-ҚАТЫНАСҚА АШЫҚ', label: 'ҚАРЫМ-ҚАТЫНАСҚА АШЫҚ' },
        { value: 'ЖАЛҒЫЗ АДАМ', label: 'ЖАЛҒЫЗ АДАМ' },
        { value: 'ОПТИМИСТ', label: 'ОПТИМИСТ' },
        { value: 'ҰЙЫМДАСТЫРУШЫ', label: 'ҰЙЫМДАСТЫРУШЫ' },
        { value: 'БІРЕГЕЙ', label: 'БІРЕГЕЙ' },
        { value: 'ЖАУАПТЫ', label: 'ЖАУАПТЫ' },
        { value: 'ҰҚЫПТЫ', label: 'ҰҚЫПТЫ' },
        { value: 'ҮЗДІК', label: 'ҮЗДІК' },
        { value: 'ЖИЕН, БӨЛЕ', label: 'ЖИЕН, БӨЛЕ' },
        { value: 'ТАПҚЫР', label: 'ТАПҚЫР' },
        { value: 'ПРИНЦИПТІ АДАМ', label: 'ПРИНЦИПТІ АДАМ' },
        { value: 'РЕАЛИСТ', label: 'РЕАЛИСТ' },
        { value: 'ДЕРБЕС', label: 'ДЕРБЕС' },
        { value: 'МЫҚТЫ АДАМ', label: 'МЫҚТЫ АДАМ' },
        { value: 'ҚАБІЛЕТТІ АДАМ', label: 'ҚАБІЛЕТТІ АДАМ' },
        { value: 'ШЫҒАРМАШЫЛ', label: 'ШЫҒАРМАШЫЛ' },
        { value: 'ӘДІЛЕТТІ', label: 'ӘДІЛЕТТІ' },
        { value: 'СТРЕСКЕ ТӨЗІМДІ', label: 'СТРЕСКЕ ТӨЗІМДІ' },
        { value: 'ТАЛАНТТЫ АДАМ', label: 'ТАЛАНТТЫ АДАМ' },
        { value: 'ОҚУШЫ', label: 'ОҚУШЫ' },
        { value: 'ҚҰРМЕТТІ АДАМ', label: 'ҚҰРМЕТТІ АДАМ' },
        { value: 'АҚЫЛДЫ', label: 'АҚЫЛДЫ' },
        { value: 'ЕРЕКШЕ', label: 'ЕРЕКШЕ' },
        { value: 'ФИЗИКАЛЫҚ ЕПТІ', label: 'ФИЗИКАЛЫҚ ЕПТІ' },
        { value: 'ФИЗИКАЛЫҚ МЫҚТЫ', label: 'ФИЗИКАЛЫҚ МЫҚТЫ' },
        { value: 'МАҚСАТҚА БАҒЫТТАЛҒАН АДАМ', label: 'МАҚСАТҚА БАҒЫТТАЛҒАН АДАМ' },
        { value: 'ӘДЕМІЛІКТІ БАҒАЛАУШЫ', label: 'ӘДЕМІЛІКТІ БАҒАЛАУШЫ' },
        { value: 'АДАЛ АДАМ', label: 'АДАЛ АДАМ' },
        { value: 'СЕЗІМТАЛ', label: 'СЕЗІМТАЛ' },
        { value: 'ЭРУДИТ (БІЛІМДІ)', label: 'ЭРУДИТ (БІЛІМДІ)' }
      ],
      optionsConceptsRU: [
        { role: "БРАТ-СЕСТРА", concepts: ["Я-Социальное", "Я-Физическое"] },
        { role: "БОГАТЫЙ ЧЕЛОВЕК", concepts: ["Я-Предметное"] },
        { role: "ВДОХНОВИТЕЛЬ", concepts: ["Я-Социальное", "Я-Интеллектуальное", "Я-Профессиональное"] },
        { role: "ВНУК-ВНУЧКА", concepts: ["Я-Социальное", "Я-Физическое"] },
        { role: "ВЕСЕЛЬЧАК", concepts: ["Я-Социальное", "Я –Духовное"] },
        { role: "ВОЛЕВОЙ ЧЕЛОВЕК", concepts: ["Я-Интеллектуальное", "Я-Профессиональное", "Я –Духовное", "Я предметное"] },
        { role: "ГАРМОНИЧНЫЙ", concepts: ["Я-Физическое", "Я –Духовное"] },
        { role: "ДЕВОЧКА-МАЛЬЧИК", concepts: ["Я-Физическое", "Я-Социальное"] },
        { role: "ДОЧЬ-СЫН", concepts: ["Я-Социальное", "Я-Физическое"] },
        { role: "ДУША КОМПАНИИ", concepts: ["Я-Социальное", "Я –Духовное"] },
        { role: "ЗДОРОВЫЙ ЧЕЛОВЕК", concepts: ["Я-Физическое", "Я-Предметное"] },
        { role: "ИДЕАЛИСТ", concepts: ["Я –Духовное"] },
        { role: "ИНИЦИАТОР", concepts: ["Я-Социальное", "Я-Профессиональное"] },
        { role: "ИСПОЛНИТЕЛЬ", concepts: ["Я-Социальное", "Я-Профессиональное"] },
        { role: "КОЛЛЕКТИВИСТ", concepts: ["Я-Социальное", "Я-Профессиональное"] },
        { role: "КРАСИВЫЙ ЧЕЛОВЕК", concepts: ["Я-Физическое", "Я-Предметное"] },
        { role: "КРИТИК", concepts: ["Я-Социальное", "Я-Профессиональное", "Я-Интеллектуальное"] },
        { role: "ЛИДЕР", concepts: ["Я-Социальное", "Я-Профессиональное"] },
        { role: "МАТЕМАТИК", concepts: ["Я-Интеллектуальное", "Я-Профессиональное"] },
        { role: "МОДНИК", concepts: ["Я-Социальное", "Я-Профессиональное", "Я-Предметное"] },
        { role: "МОТИВАТОР", concepts: ["Я-Социальное", "Я-Профессиональное", "Я-Предметное"] },
        { role: "НАДЕЖНЫЙ ДРУГ", concepts: ["Я-Социальное", "Я –Духовное"] },
        { role: "НАХОДЧИВЫЙ ЧЕЛОВЕК", concepts: ["Я-Профессиональное", "Я-Интеллектуальное"] },
        { role: "НРАВСТВЕННЫЙ ЧЕЛОВЕК", concepts: ["Я-Социальное", "Я –Духовное"] },
        { role: "ОБЩИТЕЛЬНЫЙ ЧЕЛОВЕК", concepts: ["Я-Социальное", "Я-Профессиональное"] },
        { role: "ОДИНОЧКА", concepts: ["Я –Духовное"] },
        { role: "ОПТИМИСТ", concepts: ["Я-Социальное", "Я –Духовное", "Я-Интеллектуальное"] },
        { role: "ОРГАНИЗАТОР", concepts: ["Я-Социальное", "Я-Профессиональное"] },
        { role: "ОРИГИНАЛ", concepts: ["Я-Профессиональное", "Я-Интеллектуальное"] },
        { role: "ОТВЕТСТВЕННЫЙ", concepts: ["Я-Профессиональное", "Я-Социальное"] },
        { role: "ОТЗЫВЧИВЫЙ", concepts: ["Я-Социальное", "Я –Духовное"] },
        { role: "ОТЛИЧНИК", concepts: ["Я-Профессиональное", "Я-Интеллектуальное"] },
        { role: "ПЛЕМЯННИК-ПЛЕМЯННИЦА", concepts: ["Я-Социальное", "Я-Физическое"] },
        { role: "ПРЕДПРИИМЧИВЫЙ", concepts: ["Я-Профессиональное", "Я-Интеллектуальное"] },
        { role: "ПРИНЦИПИАЛЬНЫЙ ЧЕЛОВЕК", concepts: ["Я-Профессиональное", "Я –Духовное"] },
        { role: "РЕАЛИСТ", concepts: ["Я-Профессиональное", "Я-Интеллектуальное", "Я –Духовное"] },
        { role: "САМОСТОЯТЕЛЬНЫЙ", concepts: ["Я-Профессиональное", "Я-Интеллектуальное", "Я –Духовное"] },
        { role: "СИЛЬНЫЙ ЧЕЛОВЕК", concepts: ["Я-Физическое"] },
        { role: "СПОСОБНЫЙ ЧЕЛОВЕК", concepts: ["Я-Профессиональное", "Я-Интеллектуальное"] },
        { role: "СПРАВЕДЛИВЫЙ", concepts: ["Я-Социальное", "Я –Духовное"] },
        { role: "СТРЕССОУСТОЙЧИВЫЙ", concepts: ["Я-Физическое"] },
        { role: "ТАЛАНТЛИВЫЙ ЧЕЛОВЕК", concepts: ["Я-Профессиональное", "Я-Интеллектуальное"] },
        { role: "ТВОРЧЕСКИЙ", concepts: ["Я-Профессиональное", "Я-Интеллектуальное", "Я –Духовное"] },
        { role: "УЧЕНИК (ЦА)", concepts: ["Я-Интеллектуальное", "Я-Профессиональное"] },
        { role: "УВАЖАЕМЫЙ ЧЕЛОВЕК", concepts: ["Я-Социальное", "Я-Профессиональное"] },
        { role: "УМНЫЙ", concepts: ["Я-Профессиональное", "Я-Интеллектуальное"] },
        { role: "УНИКАЛЬНЫЙ", concepts: ["Я –Духовное"] },
        { role: "ФИЗИЧЕСКИ ЛОВКИЙ", concepts: ["Я-Физическое", "Я-Профессиональное"] },
        { role: "ФИЗИЧЕСКИ РАЗВИТЫЙ", concepts: ["Я-Физическое"] },
        { role: "ЦЕЛЕУСТРЕМЛЕННЫЙ ЧЕЛОВЕК", concepts: ["Я-Профессиональное", "Я-Предметное"] },
        { role: "ЦЕНИТЕЛЬ ПРЕКРАСНОГО", concepts: ["Я –Духовное"] },
        { role: "ЧЕСТНЫЙ ЧЕЛОВЕК", concepts: ["Я –Духовное"] },
        { role: "ЧУВСТВИТЕЛЬНЫЙ", concepts: ["Я –Духовное"] },
        { role: "ЭРУДИТ (НАЧИТАННЫЙ)", concepts: ["Я-Профессиональное", "Я-Интеллектуальное"] }
      ],
      optionsConceptsKZ: [
        { role: 'АҒА-ӘПКЕ (ТӘТЕ)', concepts: ["Әлеуметтік Мен", "Физикалық Мен"] },
        { role: 'БАЙ АДАМ', concepts: ["Пәндік Мен"] },
        { role: 'ШАБЫТТАНДЫРУШЫ', concepts: ["Әлеуметтік Мен", "Интеллектуалды Мен", "Кәсіби Мен"] },
        { role: 'НЕМЕРЕ', concepts: ["Әлеуметтік Мен", "Физикалық Мен"] },
        { role: 'КӨҢІЛДІ АДАМ', concepts: ["Әлеуметтік Мен", "Рухани Мен"] },
        { role: 'ЕРІК КҮШІ МЫҚТЫ АДАМ', concepts: ["Интеллектуалды Мен", "Кәсіби Мен", "Рухани Мен", "Пәндік Мен"] },
        { role: 'ҮЙЛЕСІМДІ', concepts: ["Физикалық Ме", "Рухани Мен"] },
        { role: 'ҰЛ-ҚЫЗ', concepts: ["Физикалық Мен", "Әлеуметтік Мен"] },
        { role: 'ҰЛЫМ-ҚЫЗЫМ', concepts: ["Әлеуметтік Мен", "Физикалық Мен"] },
        { role: 'КОМПАНИЯНЫҢ ЖАНЫ', concepts: ["Әлеуметтік Мен", "Рухани Мен"] },
        { role: 'ДЕНСАУЛЫҒЫ МЫҚТЫ', concepts: ["Физикалық Мен", "Пәндік Мен"] },
        { role: 'ИДЕАЛИСТ', concepts: ["Рухани Мен"] },
        { role: 'ИНИЦИАТОР', concepts: ["Әлеуметтік Мен", "Кәсіби Мен"] },
        { role: 'ОРЫНДАУШЫ', concepts: ["Әлеуметтік Мен", "Кәсіби Мен"] },
        { role: 'КӨПШІЛ', concepts: ["Әлеуметтік Мен", "Кәсіби Мен"] },
        { role: 'ӘДЕМІ АДАМ', concepts: ["Әлеуметтік Мен", "Пәндік Мен"] },
        { role: 'СЫНШЫ', concepts: ["Әлеуметтік Мен", "Кәсіби Мен", "Интеллектуалды Мен"] },
        { role: 'КӨШБАСШЫ', concepts: ["Әлеуметтік Мен", "Кәсіби Мен"] },
        { role: 'МАТЕМАТИК', concepts: ["Интеллектуалды Мен", "Кәсіби Мен"] },
        { role: 'СӘНҚОЙ', concepts: ["Әлеуметтік Мен", "Кәсіби Мен", "Пәндік Мен"] },
        { role: 'МОТИВАТОР', concepts: ["Әлеуметтік Мен", "Кәсіби Мен", "Пәндік Мен"] },
        { role: 'СЕНІМДІ ДОС', concepts: ["Әлеуметтік Мен", "Рухани Мен"] },
        { role: 'ТАПҚЫР АДАМ', concepts: ["Кәсіби Мен", "Интеллектуалды Мен"] },
        { role: 'АДАМГЕРШІЛІГІ ЖОҒАРЫ', concepts: ["Әлеуметтік Мен", "Рухани Мен"] },
        { role: 'ҚАРЫМ-ҚАТЫНАСҚА АШЫҚ', concepts: ["Әлеуметтік Мен", "Кәсіби Мен"] },
        { role: 'ЖАЛҒЫЗ АДАМ', concepts: ["Рухани Мен"] },
        { role: 'ОПТИМИСТ', concepts: ["Әлеуметтік Мен", "Рухани Мен", "Интеллектуалды Мен"] },
        { role: 'ҰЙЫМДАСТЫРУШЫ', concepts: ["Әлеуметтік Мен", "Кәсіби Мен"] },
        { role: 'БІРЕГЕЙ', concepts: ["Кәсіби Мен", "Интеллектуалды Мен"] },
        { role: 'ЖАУАПТЫ', concepts: ["Кәсіби Мен"] },
        { role: 'ҰҚЫПТЫ', concepts: ["Әлеуметтік Мен", "Рухани Мен"] },
        { role: 'ҮЗДІК', concepts: ["Кәсіби Мен", "Интеллектуалды Мен"] },
        { role: 'ЖИЕН, БӨЛЕ', concepts: ["Әлеуметтік Мен", "Физикалық Мен"] },
        { role: 'ТАПҚЫР', concepts: ["Кәсіби Мен", "Интеллектуалды Мен"] },
        { role: 'ПРИНЦИПТІ АДАМ', concepts: ["Кәсіби Мен", "Рухани Мен"] },
        { role: 'РЕАЛИСТ', concepts: ["Кәсіби Мен", "Интеллектуалды Мен", "Рухани Мен"] },
        { role: 'ДЕРБЕС', concepts: ["Кәсіби Мен", "Интеллектуалды Мен", "Рухани Мен"] },
        { role: 'МЫҚТЫ АДАМ', concepts: ["Физикалық Мен"] },
        { role: 'ҚАБІЛЕТТІ АДАМ', concepts: ["Кәсіби Мен", "Интеллектуалды Мен"] },
        { role: 'ШЫҒАРМАШЫЛ', concepts: ["Кәсіби Мен", "Интеллектуалды Мен", "Рухани Мен"] },
        { role: 'ӘДІЛЕТТІ', concepts: ["Әлеуметтік Мен", "Рухани Мен"] },
        { role: 'СТРЕСКЕ ТӨЗІМДІ', concepts: ["Физикалық Мен"] },
        { role: 'ТАЛАНТТЫ АДАМ', concepts: ["Кәсіби Мен", "Интеллектуалды Мен"] },
        { role: 'ОҚУШЫ', concepts: ["Интеллектуалды Мен", "Кәсіби Мен"] },
        { role: 'ҚҰРМЕТТІ АДАМ', concepts: ["Әлеуметтік Мен", "Кәсіби Мен"] },
        { role: 'АҚЫЛДЫ', concepts: ["Кәсіби Мен", "Интеллектуалды Мен"] },
        { role: 'ЕРЕКШЕ', concepts: ["Рухани Мен"] },
        { role: 'ФИЗИКАЛЫҚ ЕПТІ', concepts: ["Физикалық Мен", "Кәсіби Мен"] },
        { role: 'ФИЗИКАЛЫҚ МЫҚТЫ', concepts: ["Физикалық Мен"] },
        { role: 'МАҚСАТҚА БАҒЫТТАЛҒАН АДАМ', concepts: ["Кәсіби Мен", "Пәндік Мен"] },
        { role: 'ӘДЕМІЛІКТІ БАҒАЛАУШЫ', concepts: ["Рухани Мен"] },
        { role: 'АДАЛ АДАМ', concepts: ["Рухани Мен"] },
        { role: 'СЕЗІМТАЛ', concepts: ["Рухани Мен"] },
        { role: 'ЭРУДИТ (БІЛІМДІ)', concepts: ["Кәсіби Мен", "Интеллектуалды Мен"] }
      ],
      communicationsAnswers: {
        communicationsFirstPlace: {sphere: '', role: ''},
        communicationsSecondPlace: {sphere: '', role: ''},
        communicationsThirdPlace: {sphere: '', role: ''},
      },
    }
  },
  methods: {
    openModal() {
      this.$bvModal.show('exit-modal');
    },
    async sendCommunicationsResults() {

      const uniqueSpheres = [];

      for (const key in this.communicationsAnswers) {
        const sphere = this.communicationsAnswers[key].sphere;
        if (!uniqueSpheres.includes(sphere)) {
          uniqueSpheres.push(sphere);
        } else {
          return Vue.toastr({
            message: 'Error',
            description: 'Вы должны выбрать сферы и они не должны повторяться!',
            type: 'error'
          })
        }
      }

      const roles = [
        this.communicationsAnswers.communicationsFirstPlace.role,
        this.communicationsAnswers.communicationsSecondPlace.role,
        this.communicationsAnswers.communicationsThirdPlace.role,
      ];

      console.log('roles', roles);


      let scores = [];

      roles.forEach((roleArr, outerIndex) => {
        roleArr.forEach((role, innerIndex) => {
          const points = 3 - outerIndex;
          const existingRole = scores.find((item) => item.role === role);
          if (existingRole) {
            existingRole.score += points;
          } else {
            scores.push({ role, score: points });
          }
        });
      });

      scores.sort((a, b) => b.score - a.score);

      let test_lang = localStorage.getItem('test_lang')

      if (test_lang == 'ru'){
        scores = scores.map( item => {
          return {...item, concept: this.optionsConceptsRU.filter(concept => concept.role == item.role)[0].concepts}
        })
      } else {
        scores = scores.map( item => {
          return {...item, concept: this.optionsConceptsKZ.filter(concept => concept.role == item.role)[0].concepts}
        })
      }


      const concepts = [
        { concept: "Я-Социальное", score: 0 },
        { concept: "Я-Предметное", score: 0 },
        { concept: "Я-Физическое", score: 0 },
        { concept: "Я-Интеллектуальное", score: 0 },
        { concept: "Я-Профессиональное", score: 0 },
        { concept: "Я-Духовное", score: 0 }
      ];

      const conceptsKZ = [
        { concept: "Әлеуметтік Мен", score: 0 },
        { concept: "Пәндік Мен", score: 0 },
        { concept: "Физикалық Мен", score: 0 },
        { concept: "Интеллектуалды Мен", score: 0 },
        { concept: "Кәсіби Мен", score: 0 },
        { concept: "Рухани Мен", score: 0 }
      ];

      if (test_lang == 'ru'){
        scores.forEach(item => {
          item.concept.forEach(concept => {
            switch (concept) {
              case 'Я-Социальное':
                concepts[0].score += item.score;
                break;
              case 'Я-Предметное':
                concepts[1].score += item.score;
                break;
              case 'Я-Физическое':
                concepts[2].score += item.score;
                break;
              case 'Я-Интеллектуальное':
                concepts[3].score += item.score;
                break;
              case 'Я-Профессиональное':
                concepts[4].score += item.score;
                break;
              case 'Я-Духовное':
                concepts[5].score += item.score;
                break;
            }
          });
        });
      } else {
        scores.forEach(item => {
          item.concept.forEach(concept => {
            switch (concept) {
              case 'Әлеуметтік Мен':
                conceptsKZ[0].score += item.score;
                break;
              case 'Пәндік Мен':
                conceptsKZ[1].score += item.score;
                break;
              case 'Физикалық Мен':
                conceptsKZ[2].score += item.score;
                break;
              case 'Интеллектуалды Мен':
                conceptsKZ[3].score += item.score;
                break;
              case 'Кәсіби Мен':
                conceptsKZ[4].score += item.score;
                break;
              case 'Рухани Мен':
                conceptsKZ[5].score += item.score;
                break;
            }
          });
        });
      }

      const params = JSON.parse(localStorage.getItem('quiz-params'))

      let communicationsSendAnswers;

      let textsInterpretation = {};

      textsInterpretation.ru = concepts.sort((a, b) => b.score - a.score).map((item, index) => `${index + 1} место: ${item.concept}. `).join("<br>")
      textsInterpretation.ru = textsInterpretation.ru + "<br>" + `Уровень способностей к коммуникации: ${this.determineLevel(scores.length, "ru")}.`

      textsInterpretation.kz = conceptsKZ.sort((a, b) => b.score - a.score).map((item, index) => `${index + 1} орын: ${item.concept}. `).join("<br>")
      textsInterpretation.kz = textsInterpretation.kz + "<br>" + `Коммуникация қабілетінің деңгейі: ${this.determineLevel(scores.length, "kz")}.`

      textsInterpretation.ru = textsInterpretation.ru + "<br> 1. Развивать коммуникативные способности через преобладающий Профиль «Я-концепции». Например:<br> - если у тебя преобладает профиль Я-Социальное, то важно развивать умение социального признания, делать комплименты, знать свои положительные качества, умение решать конфликты;<br> - если у тебя преобладает профиль Я-Предметное, то возможно тебя вдохновляет красивое окружение, умение стильно одеваться, достижения в материальном мире, стоит уделять этому внимание, и получать признание этих способностей со стороны значимых людей;<br> - если у тебя преобладает профиль Я-Физическое, то здесь важно уделять внимание своему здоровью, развитию гармоничному своего тела, не поддаваться на стереотипы и ложные стандарты красоты, при этом уметь получать удовольствие от тех благ, которые связаны с телесными ощущениями;<br> - если у тебя преобладает профиль Я-Интеллектуальное, здесь важно продолжать развивать именно эту сферу, эрудицию, получать удовольствие от решения интересных и сложных умственных задач, найти, где это применимо в социальной жизни и чем может быть полезно;<br> - если у тебя преобладает профиль Я-Профессиональное, то стоит искать себя в проявлении разных профессиональных компетенций и найти единомышленников в данной сфере, чтобы почувствовать зоны своего роста и мотивацию к постоянному развитию;<br> - если у тебя преобладает профиль Я-Духовное, то важно уделять внимание эрудиции в области искусства, культуры и эстетического развития, найти единомышленников, с кем можно было этим делиться и получать вдохновение, заниматься творчеством, посещать музеи и музыкальные мероприятия.<br> 2. Развивать слабо выраженный профиль Я-концепции для гармоничного развития личности, так как это может способствовать успешной коммуникации. А именно: если у тебя какой-либо профиль выражен слабо, то для гармоничного развития желательно пройти тренинг, который раскроет твой потенциал более полно и даст тебе больше возможностей в жизни. <br> В твоем возрасте развивается умение узнавать себя с разных сторон, в разных сферах жизни, ролях и ситуациях. Самое время развивать свой потенциал, свое Я."
      textsInterpretation.kz = textsInterpretation.kz + "<br> 1. \"Мен-тұжырымдамасы\" профилі арқылы коммуникативті қабілеттерді дамыту. Мысалы:<br> - егер сізде Әлеуметтік Мен профилі басым болса, онда сіздің жағымды қасиеттеріңізді дамыту маңызды. Ол үшін еріктілер қозғалысына, пікірталас клубына, шешендік өнерге, көшбасшылық дағдыларға және басқа да әлеуметтік маңызды жобаларға қатысуға болады.<br> - егер сізде Пәндік Мен профилі басым болса, онда өзіңізге хобби табуға болады, мысалы, бір нәрсені модельдеу немесе қолыңызбен жасау, аспаздық қабілеттерін дамыту, стиль мен дизайн бойынша заманауи трендтерді үйрену және т. б.<br> - егер сізде Физикалық Мен профилі басым болса, стереотиптер мен сұлулықтың жалған стандарттарына мойынсұнбай, денсаулығыңызға, денеңіздің үйлесімді дамуына назар аударуды жалғастырыңыз. Мұны істеу үшін, мысалы, белгілі бір уақытта (бір айда немесе алты айда) физикалық қасиеттердің 5 бағыты бойынша жетістіктерді арттыруға мақсат қоюға болады: жылдамдық, күш, төзімділік, ептілік және икемділік, қатысу үшін спорт секцияларын таңдау керек.<br> - егер сізде Интеллектуалды Мен профиліңіз басым болса, осы саланы, эрудицияны дамыта беріңіз, қызықты және күрделі психикалық мәселелерді шешуден ләззат алыңыз, оның әлеуметтік өмірде қай жерде қолданылатынын және пайдалы болуы мүмкін екенін табыңыз. Ол үшін ғылыми пікірталастар, ой-талқылар өтетін клубтар мен секцияларға, әлеуметтік желілердегі парақшаларға қатысуға, ғылыми жобалар мен олимпиадаларға, оның ішінде мүдделер командасының құрамына қатысуға болады.<br> - егер сізде Кәсіби Мен профилі басым болса, сіздің кәсіби қалауыңызды анықтап, осы салада пікірлес адамдарды табу маңызды. Ол үшін жобалар мен олимпиадаларға, оның ішінде қызығушылықтары ұқсас адамдар командасының құрамына қатысуға болады. Табысты адамдардың тарихы мен өмірбаянын зерттеп, мамандардың тәжірибесімен танысуға мүмкіндік табыңыз.<br> - егер сізде Рухани Мен профиліңіз басым болса, өнер, мәдениет және эстетикалық даму саласындағы эрудицияға назар аудару, онымен бөлісуге және шабыт алуға, шығармашылықпен айналысуға, мұражайлар мен музыкалық іс-шараларға қатысуға болатын пікірлестерді табу маңызды."

      if (test_lang == 'ru') {
        communicationsSendAnswers = [
          this.communicationsAnswers, {scores}, {concepts}, {textsInterpretation}
        ]
      } else {
        communicationsSendAnswers = [
          this.communicationsAnswers, {scores}, {conceptsKZ}, {textsInterpretation}
        ]
      }

      params.answer_id = {...params.answer_id, communicationsSendAnswers}

      // params.answer_id.push(communicationsSendAnswers)

      localStorage.setItem('quiz-params', JSON.stringify(params))
      const quizToken = localStorage.getItem('quiz-token')

      const response = await this.$http.post(API_ROOT + '/api/user-answer/' + quizToken, params)

      if (response.body.status == 'success') {

        Vue.toastr({
          message: this.$t('successful'),
          description: this.$t('saved-successfully'),
          type: 'success'
        })
      } else {
        Vue.toastr({
          message: this.$t('error-title'),
          description: this.$t('error-saving'),
          type: 'error'
        })
      }

      console.log('scores', scores);
      console.log('concepts', concepts);
      console.log('conceptsKZ', conceptsKZ);
      console.log('params', params);
      console.log('communicationsAnswers', this.communicationsAnswers)

      setTimeout(() => {
        this.$router.push({ path: '/about-new/self-esteem' })
      }, 1500)

    },
    determineLevel(count, lang) {
      if (count >= 20) {
        return lang == "ru" ? "высокий" : "жоғары деңгей";
      } else if (count >= 11) {
        return lang == "ru" ? "средний" : "орташа деңгей";
      } else {
        return lang == "ru" ? "в зоне ближайшего развития" : "жақын даму аймағында";
      }
    },
    startTimer(duration) {
      let timer = duration, minutes, seconds;
      this.timerInterval = setInterval(() => {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        this.countdown = minutes + ":" + seconds;

        let savedTimer = (parseInt(minutes) * 60) + parseInt(seconds);
        localStorage.setItem('timerСommunications', savedTimer);

        if (--timer < 0) {
          this.sendCommunicationsResults()
          clearInterval(this.timerInterval);
          // this.saveAnswer();
          // this.exit();
          // timer = duration;
        }
      }, 1000);
    }
  },
  mounted() {
    if (localStorage.getItem('timerСommunications')) {
      this.startTimer(localStorage.getItem('timerСommunications'))
    } else {
      this.startTimer(1800)
    }

    let test_lang = localStorage.getItem('test_lang')

    if (test_lang){
      this.$i18n.locale = test_lang;
    }
  }
}
</script>

<style>

.communications-table {
  border-collapse: collapse;
  width: 100%;
}

.communications-table th, td {
  border: 1px solid black;
  text-align: center;
  padding: 8px;
}

.communications-table th {
  background-color: #f2f2f2;
}

</style>
